export const Kitchen = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3 15H13V21H3C2.44772 21 2 20.5523 2 20V16C2 15.4477 2.44772 15 3 15Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H13V4C13 3.44772 13.4477 3 14 3Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.49951 3H3.50051C3.04165 3 2.64166 3.3123 2.53037 3.75746L2.03037 5.75746C1.95569 6.0562 2.0228 6.37269 2.2123 6.6154C2.4018 6.85812 2.69256 6.99999 3.00049 7H8.99949C9.30743 7 9.59819 6.85813 9.7877 6.61541C9.9772 6.37269 10.0443 6.0562 9.96963 5.75746L9.46963 3.75746C9.35834 3.3123 8.95837 3.00001 8.49951 3Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22 11H13"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 10V11"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 10V11"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9 10V11"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Kitchen</div>
    </div>
  );
};

export const ForkKnife = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 3.08398V7.54598V7.63598V7.54598C3 8.81998 3.525 9.94798 4.339 10.678C4.737 11.035 5 11.517 5 12.052V19.5C5 20.328 5.672 21 6.5 21C7.328 21 8 20.328 8 19.5V12.052C8 11.517 8.263 11.035 8.661 10.678C9.475 9.94798 10 8.81998 10 7.54598V3.08398V7.54598"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.5 8V3"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20 4.052C20 3.5 19.552 3.052 19 3.052H18C16.343 3.052 15 4.395 15 6.052V12.052C15 13.356 15.837 14.455 17 14.868V19.5C17 20.328 17.672 21 18.5 21C19.328 21 20 20.328 20 19.5V15.052V4.052Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Fork knife</div>
    </div>
  );
};

export const Stove = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17 18H7C6.448 18 6 17.552 6 17V12C6 11.448 6.448 11 7 11H17C17.552 11 18 11.448 18 12V17C18 17.552 17.552 18 17 18Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5 21H19C20.105 21 21 20.105 21 19V5C21 3.895 20.105 3 19 3H5C3.895 3 3 3.895 3 5V19C3 20.105 3.895 21 5 21Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 8H3"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Stove</div>
    </div>
  );
};

export const Induction = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.33301 10.333V10.333C7.22801 10.333 6.33301 9.43801 6.33301 8.33301V8.33301C6.33301 7.22801 7.22801 6.33301 8.33301 6.33301V6.33301C9.43801 6.33301 10.333 7.22801 10.333 8.33301V8.33301C10.333 9.43801 9.43801 10.333 8.33301 10.333Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.667 10.667V10.667C14.378 10.667 13.334 9.622 13.334 8.334V8.334C13.333 7.045 14.378 6 15.667 6V6C16.955 6 18 7.045 18 8.333V8.333C18 9.622 16.955 10.667 15.667 10.667Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.333 18V18C7.045 18 6 16.955 6 15.667V15.667C6 14.378 7.045 13.334 8.333 13.334V13.334C9.622 13.334 10.666 14.379 10.666 15.667V15.667C10.667 16.955 9.622 18 8.333 18Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.667 15.667V15.667C17.667 14.562 16.772 13.667 15.667 13.667V13.667C14.562 13.667 13.667 14.562 13.667 15.667V15.667C13.667 16.772 14.562 17.667 15.667 17.667V17.667C16.771 17.667 17.667 16.771 17.667 15.667V15.667Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19 21H5C3.895 21 3 20.105 3 19V5C3 3.895 3.895 3 5 3H19C20.105 3 21 3.895 21 5V19C21 20.105 20.105 21 19 21Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Induction</div>
    </div>
  );
};

export const Dishes = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.364 4.31802C21.8787 6.07538 21.8787 8.92462 18.364 10.682C14.8493 12.4393 9.1508 12.4393 5.6361 10.682C2.12138 8.92462 2.12138 6.07538 5.6361 4.31802C9.15082 2.56066 14.8493 2.56066 18.364 4.31802"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.5 13.501C18.689 14.896 15.576 15.828 12 15.828C8.424 15.828 5.311 14.896 3.5 13.501"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.5 17.673C18.689 19.068 15.576 20 12 20C8.424 20 5.311 19.068 3.5 17.673"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.34799 7C9.12599 6.401 10.464 6 12 6C13.536 6 14.874 6.401 15.652 7"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Dishes</div>
    </div>
  );
};

export const Fridge = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.25 21H6.75C5.645 21 4.75 20.105 4.75 19V4C4.75 2.895 5.645 2 6.75 2H17.25C18.355 2 19.25 2.895 19.25 4V19C19.25 20.105 18.355 21 17.25 21Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.25 11.11H4.75"
          stroke="#323232"
          stroke-width="1.5157"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16 6V8"
          stroke="#323232"
          stroke-width="1.5157"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16 14V16"
          stroke="#323232"
          stroke-width="1.5157"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Fridge</div>
    </div>
  );
};

export const TableChair = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 11H22"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 21V11"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13 21V11"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5 14.5H9C9.55228 14.5 10 14.9477 10 15.5V16.5C10 17.0523 9.55228 17.5 9 17.5H3C2.44772 17.5 2 17.0523 2 16.5V7.5C2 6.94772 2.44772 6.5 3 6.5H4C4.55228 6.5 5 6.94772 5 7.5V14.5Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13 19H21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9 17.5V21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 21V17.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Table chair</div>
    </div>
  );
};

export const CoffeeMachine = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.99832 8.99871V7.99829"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.0021 10.9996H18.0025"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.0021 14.0008H18.0025"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.0021 17.002H18.0025"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.0008 7.9983V18.0025H3.99666C3.44415 18.0025 2.99625 18.4504 2.99625 19.0029V20.0033C2.99625 20.5558 3.44415 21.0037 3.99666 21.0037H19.0029C20.1079 21.0037 21.0037 20.1079 21.0037 19.0029V4.99705C21.0037 3.89202 20.1079 2.99622 19.0029 2.99622H4.99708C3.89205 2.99622 2.99625 3.89202 2.99625 4.99705V5.99747C2.99625 7.1025 3.89205 7.9983 4.99708 7.9983H14.0008Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.99749 12H9.99915C10.5517 12 10.9996 12.4479 10.9996 13.0004V15.0013C10.9996 16.6588 9.65586 18.0025 7.99832 18.0025V18.0025C6.34078 18.0025 4.99707 16.6588 4.99707 15.0013V13.0004C4.99707 12.4479 5.44497 12 5.99749 12Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.99751 12H3.99667"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Coffee machine</div>
    </div>
  );
};

export const Blender = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.9426 4.99703H5.05634"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.9996 16.0017V8.99878"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.99915 13.0005H12"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.99915 9.99911H12"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.2356 14.0008H17.7295C18.7643 14.0008 19.6284 13.2117 19.7221 12.1812L19.9949 9.1799C20.0458 8.62006 19.8589 8.06463 19.4798 7.64952C19.1007 7.23441 18.5645 6.99792 18.0023 6.99792H16.8722"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.0537 16.0017L16.9938 5.65999C17.033 5.22965 16.9317 4.79822 16.7053 4.43021L16.3791 3.90027C15.6508 2.71678 14.3607 1.99585 12.9711 1.99585H9.02802C7.63841 1.99585 6.3483 2.7168 5.62002 3.90027L5.29388 4.43021C5.06741 4.79823 4.96617 5.22967 5.00529 5.66001L5.94547 16.0017H6.04952"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.9688 19.5867L17.6232 17.6856C17.4459 16.7105 16.5966 16.0017 15.6056 16.0017H6.39358C5.40252 16.0017 4.55327 16.7105 4.37598 17.6856L4.03032 19.5867C3.92154 20.185 4.08389 20.8007 4.47351 21.2675C4.86313 21.7343 5.43984 22.0042 6.04792 22.0042H15.9512C16.5593 22.0042 17.136 21.7343 17.5256 21.2675C17.9153 20.8007 18.0776 20.185 17.9688 19.5867Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.0496 18.9301C11.0496 18.9577 11.0272 18.98 10.9996 18.98C10.972 18.98 10.9496 18.9576 10.9496 18.93C10.9496 18.9024 10.9719 18.88 10.9995 18.88C11.0128 18.88 11.0256 18.8853 11.035 18.8946C11.0444 18.904 11.0496 18.9168 11.0496 18.9301"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Blender</div>
    </div>
  );
};

export const SaltPepper = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="6.99791"
          y="5.99744"
          width="10.0042"
          height="3.00125"
          rx="1.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.99832 5.99752C7.99832 3.78746 9.78993 1.99585 12 1.99585C14.21 1.99585 16.0017 3.78746 16.0017 5.99752"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.10755 10.7293L6.01619 18.7326C5.93812 19.3051 6.11136 19.8834 6.49132 20.3187C6.87129 20.754 7.42088 21.0038 7.99868 21.0038H16.0013C16.5791 21.0038 17.1287 20.754 17.5087 20.3187C17.8886 19.8834 18.0619 19.3051 17.9838 18.7326L16.8924 10.7293C16.7573 9.73789 15.9105 8.99878 14.91 8.99878H9.09003C8.08948 8.99878 7.24274 9.73789 7.10755 10.7293Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Salt pepper</div>
    </div>
  );
};

export const DishWasher = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.0029 21.0037H4.99708C3.89205 21.0037 2.99625 20.1079 2.99625 19.0029V4.99705C2.99625 3.89202 3.89205 2.99622 4.99708 2.99622H19.0029C20.1079 2.99622 21.0037 3.89202 21.0037 4.99705V19.0029C21.0037 20.1079 20.1079 21.0037 19.0029 21.0037Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.0037 8.99874H2.99625"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.99918 5.99752H14.0008"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.4831 12.2408L13.9212 14.1652C14.4652 14.8921 14.5524 15.8638 14.1464 16.6759C13.7404 17.4881 12.9108 18.0015 12.0029 18.0025V18.0025C11.0949 18.0014 10.2654 17.488 9.85928 16.676C9.4532 15.864 9.54013 14.8923 10.0839 14.1652L11.5227 12.2408C11.6358 12.0893 11.8138 12 12.0029 12C12.192 12 12.37 12.0893 12.4831 12.2408V12.2408Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Dish washer</div>
    </div>
  );
};

export const WineGlass = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 5.25H9"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18 17V17C15.855 17 14.215 15.092 14.541 12.977L15.488 6.847C15.563 6.36 15.984 6 16.479 6H19.741C20.249 6 20.677 6.379 20.736 6.882L21.475 13.097C21.722 15.174 20.096 17 18 17Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.73901 10.962L4.88001 11.675C6.17701 12.486 7.82301 12.486 9.12001 11.675L10.261 10.962"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.5 2H7.5C8.052 2 8.5 2.448 8.5 3V5.085C8.5 6.993 9.018 8.865 10 10.5V10.5C10.982 12.136 11.5 14.008 11.5 15.915V20C11.5 21.105 10.605 22 9.5 22H4.5C3.395 22 2.5 21.105 2.5 20V15.915C2.5 14.007 3.018 12.135 4 10.5V10.5C4.982 8.864 5.5 6.992 5.5 5.085V3C5.5 2.448 5.948 2 6.5 2Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.98601 15C8.83201 15 9.40001 15.745 9.40001 16.439C9.40001 17.847 7.04301 19 7.00001 19C6.95701 19 4.60001 17.847 4.60001 16.439C4.60001 15.745 5.16801 15 6.01401 15C6.49801 15 6.81601 15.226 7.00001 15.428C7.18401 15.226 7.50201 15 7.98601 15V15Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 17V22"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16 22H20"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.11 10H15"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Wine</div>
    </div>
  );
};

export const Trash = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.138 21H7.858C6.811 21 5.941 20.192 5.863 19.147L4.966 7H19L18.133 19.142C18.058 20.189 17.187 21 16.138 21V21Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 11V17"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4 7H20"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17 7L15.987 4.298C15.694 3.517 14.948 3 14.114 3H9.886C9.052 3 8.306 3.517 8.013 4.298L7 7"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.43 11L15 17"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.57 11L9 17"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Trash</div>
    </div>
  );
};

export const PlateFork = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 7.5H3"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.0741 21V12"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 7.5V3"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 21C16.0294 21 12 16.9706 12 12C12 7.02944 16.0294 3 21 3"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 17C18.2386 17 16 14.7614 16 12C16 9.23858 18.2386 7 21 7"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9 3V9C9 10.6569 7.65685 12 6 12V12C4.34315 12 3 10.6569 3 9V3"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div>Plate fork</div>
    </div>
  );
};
